import React from 'react';
import styles from './TemplateCard.module.css';

const HEADER_PLACEHOLDERS = ['title', 'grade_level', 'duration', 'subject'];

export default function TemplateCard({
  template,
  isDefault,
  isSelected,
  onSelect,
  onEdit,
  onDelete,
  onSetDefault,
}) {
  const sectionPlaceholders = (template.placeholders || []).filter(
    (p) => !HEADER_PLACEHOLDERS.includes(p.name)
  );
  const sectionCount = sectionPlaceholders.length;
  const visibleSections = sectionPlaceholders.slice(0, 4);

  const cardClassName = [
    styles.card,
    isSelected ? styles.selected : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div
      className={cardClassName}
      role={onSelect ? 'button' : undefined}
      tabIndex={onSelect ? 0 : undefined}
      onClick={onSelect ? () => onSelect(template) : undefined}
      onKeyDown={
        onSelect
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onSelect(template);
              }
            }
          : undefined
      }
    >
      <div className={styles.cardBody}>
        <div className={styles.cardHeader}>
          <span className={styles.cardName}>{template.name}</span>
          {isDefault && <span className={styles.defaultBadge}>Default</span>}
        </div>

        {template.description && (
          <p className={styles.cardDescription}>{template.description}</p>
        )}

        {sectionCount > 0 && (
          <div className={styles.cardSections}>
            <span className={styles.sectionCount}>
              {sectionCount} {sectionCount === 1 ? 'section' : 'sections'}
            </span>
            <span className={styles.sectionNames}>
              {visibleSections.map((p) => p.name.replace(/_/g, ' ')).join(', ')}
              {sectionCount > 4 && `, +${sectionCount - 4} more`}
            </span>
          </div>
        )}
      </div>

      {(onEdit || onDelete || onSetDefault) && (
        <div
          className={styles.cardActions}
          onClick={(e) => e.stopPropagation()}
        >
          {!isDefault && onSetDefault && (
            <button
              className={styles.actionBtn}
              onClick={() => onSetDefault(template)}
            >
              Set Default
            </button>
          )}
          {onEdit && (
            <button
              className={styles.actionBtn}
              onClick={() => onEdit(template)}
            >
              Edit
            </button>
          )}
          {!isDefault && onDelete && (
            <button
              className={`${styles.actionBtn} ${styles.deleteAction}`}
              onClick={() => onDelete(template)}
            >
              Delete
            </button>
          )}
        </div>
      )}
    </div>
  );
}
